import type { PartDefinition } from '@rogue/rackbuilder'
import { RackOptions, SquatStandOptions, WallMountOptions, CaveOptions, CTTowerOptions, MassStorageOptions } from '../../RackTypes'

type RackConfigs = {config: Partial<RackOptions | SquatStandOptions | WallMountOptions | CaveOptions | CTTowerOptions | MassStorageOptions | {height?: number}>, part: PartDefinition}

export function areArraysIdentical<T>(a: T[], b: T[]): boolean {
  return a.length === b.length && a.every((val, i) => val === b[i])
}

export function hasMMSUnitHeightOrWidthChanged(newVal: RackConfigs, oldVal: RackConfigs): boolean {
  if (!oldVal) return true

  const newCfg = newVal?.config as MassStorageOptions
  const oldCfg = oldVal?.config as MassStorageOptions

  const getPropArray = <T extends Record<string, any>>(chain: T[] | undefined, key: string): string[] => (chain ?? []).map(unit => unit[key] as string)

  const baseHeightChanged = newCfg.height !== oldCfg.height
  const baseWidthChanged = newCfg.width !== oldCfg.width

  const newLeftHeights = getPropArray(newCfg.leftAddonChain, 'heightSelection')
  const oldLeftHeights = getPropArray(oldCfg.leftAddonChain, 'heightSelection')

  const newRightHeights = getPropArray(newCfg.rightAddonChain, 'heightSelection')
  const oldRightHeights = getPropArray(oldCfg.rightAddonChain, 'heightSelection')

  const newLeftWidths = getPropArray(newCfg.leftAddonChain, 'widthSelection')
  const oldLeftWidths = getPropArray(oldCfg.leftAddonChain, 'widthSelection')

  const newRightWidths = getPropArray(newCfg.rightAddonChain, 'widthSelection')
  const oldRightWidths = getPropArray(oldCfg.rightAddonChain, 'widthSelection')

  return (
    baseHeightChanged
    || baseWidthChanged
    || !areArraysIdentical(newLeftHeights, oldLeftHeights)
    || !areArraysIdentical(newRightHeights, oldRightHeights)
    || !areArraysIdentical(newLeftWidths, oldLeftWidths)
    || !areArraysIdentical(newRightWidths, oldRightWidths)
  )
}
